import api from "@/services/axiosInstance";

const API_BASE_URL = process.env.VUE_APP_BACKEND_URL;
const content = "inventory";
const version = "v1";

// units
export const fetchV1Units = async (page = 1, pageSize = 5) => {
  page = page ?? 1;
  pageSize = pageSize ?? 8;
  let URL = `${API_BASE_URL}/${content}/${version}/units/?page_size=${pageSize}&page=${page}`;

  console.log("units API:", URL, page, pageSize);

  try {
    const response = await api.get(URL);
    return response.data;
  } catch (error) {
    console.error("Error fetching units:", error);
    throw error;
  }
};

export const createV1Unit = async (data) => {
  const URL = `${API_BASE_URL}/${content}/${version}/units/`;
  try {
    const response = await api.post(URL, data);
    return response.data;
  } catch (error) {
    console.error("Error creating unit at service:", error);

    if (error.response && error.response.status === 403) {
      return { error: true, message: "Permission denied to create an author" };
    }

    throw error;
  }
};

// categories
export const fetchV1Categories = async (page = 1, pageSize = 5) => {
  page = page ?? 1;
  pageSize = pageSize ?? 8;
  let URL = `${API_BASE_URL}/${content}/${version}/categories/?page_size=${pageSize}&page=${page}`;

  console.log("categories API:", URL, page, pageSize);

  try {
    const response = await api.get(URL);
    return response.data;
  } catch (error) {
    console.error("Error fetching categories:", error);
    throw error;
  }
};

export const searchV1Categories = async (query = "", page = 1, pageSize = 8) => {
  page = page ?? 1;
  pageSize = pageSize ?? 8;
  const URL = `${API_BASE_URL}/${content}/${version}/categories?page_size=${pageSize}&page=${page}&search=${encodeURIComponent(
    query
  )}`;

  console.log("Search categories API:", URL);

  try {
    const response = await api.get(URL);
    return response.data;
  } catch (error) {
    console.error("Error searching categories:", error);
    throw error;
  }
};


export const createV1Category = async (data) => {
  const URL = `${API_BASE_URL}/${content}/${version}/categories/`;
  try {
    const response = await api.post(URL, data);
    return response.data;
  } catch (error) {
    console.error("Error creating categories at service:", error);

    if (error.response && error.response.status === 403) {
      return { error: true, message: "Permission denied to create an author" };
    }

    throw error;
  }
};

// sizes
export const fetchV1Sizes = async (page = 1, pageSize = 5) => {
  page = page ?? 1;
  pageSize = pageSize ?? 8;
  let URL = `${API_BASE_URL}/${content}/${version}/sizes/?page_size=${pageSize}&page=${page}`;

  console.log("Sizes API:", URL, page, pageSize);

  try {
    const response = await api.get(URL);
    return response.data;
  } catch (error) {
    console.error("Error fetching sizes:", error);
    throw error;
  }
};

export const searchV1Sizes = async (
  query = "",
  page = 1,
  pageSize = 8
) => {
  page = page ?? 1;
  pageSize = pageSize ?? 8;
  const URL = `${API_BASE_URL}/${content}/${version}/sizes?page_size=${pageSize}&page=${page}&search=${encodeURIComponent(
    query
  )}`;

  console.log("Search sizes API:", URL);

  try {
    const response = await api.get(URL);
    return response.data;
  } catch (error) {
    console.error("Error searching sizes:", error);
    throw error;
  }
};

export const createV1Size = async (data) => {
  const URL = `${API_BASE_URL}/${content}/${version}/sizes/`;
  try {
    const response = await api.post(URL, data);
    return response.data;
  } catch (error) {
    console.error("Error creating sizes at service:", error);

    if (error.response && error.response.status === 403) {
      return { error: true, message: "Permission denied" };
    }

    throw error;
  }
};

// colors
export const fetchV1Colors = async (page = 1, pageSize = 5) => {
  page = page ?? 1;
  pageSize = pageSize ?? 8;
  let URL = `${API_BASE_URL}/${content}/${version}/colors/?page_size=${pageSize}&page=${page}`;

  console.log("Colors API:", URL, page, pageSize);

  try {
    const response = await api.get(URL);
    return response.data;
  } catch (error) {
    console.error("Error fetching colors:", error);
    throw error;
  }
};

export const searchV1Colors = async (query = "", page = 1, pageSize = 8) => {
  page = page ?? 1;
  pageSize = pageSize ?? 8;
  const URL = `${API_BASE_URL}/${content}/${version}/colors?page_size=${pageSize}&page=${page}&search=${encodeURIComponent(
    query
  )}`;

  console.log("Search colors API:", URL);

  try {
    const response = await api.get(URL);
    return response.data;
  } catch (error) {
    console.error("Error searching colors:", error);
    throw error;
  }
};

export const createV1Color = async (data) => {
  const URL = `${API_BASE_URL}/${content}/${version}/colors/`;
  try {
    const response = await api.post(URL, data);
    return response.data;
  } catch (error) {
    console.error("Error creating colors at service:", error);

    if (error.response && error.response.status === 403) {
      return { error: true, message: "Permission denied" };
    }

    throw error;
  }
};

// products
export const fetchV1Products = async (page = 1, pageSize = 5) => {
  page = page ?? 1;
  pageSize = pageSize ?? 8;
  let URL = `${API_BASE_URL}/${content}/${version}/products/?page_size=${pageSize}&page=${page}`;

  console.log("Products API:", URL, page, pageSize);

  try {
    const response = await api.get(URL);
    return response.data;
  } catch (error) {
    console.error("Error fetching Products:", error);
    throw error;
  }
};

export const searchV1Products = async (query = "", page = 1, pageSize = 8) => {
  page = page ?? 1;
  pageSize = pageSize ?? 8;
  const URL = `${API_BASE_URL}/${content}/${version}/products?page_size=${pageSize}&page=${page}&search=${encodeURIComponent(
    query
  )}`;

  console.log("Search products API:", URL);

  try {
    const response = await api.get(URL);
    return response.data;
  } catch (error) {
    console.error("Error searching products:", error);
    throw error;
  }
};

export const createV1Product = async (data) => {
  const URL = `${API_BASE_URL}/${content}/${version}/products/`;
  try {
    const response = await api.post(URL, data);
    return response.data;
  } catch (error) {
    console.error("Error creating products at service:", error);

    if (error.response && error.response.status === 403) {
      return { error: true, message: "Permission denied" };
    }

    throw error;
  }
};

export const createV1ProductWithVariant = async (data) => {
  const URL = `${API_BASE_URL}/${content}/${version}/product-with-variant/`;
  try {
    const response = await api.post(URL, data);
    return response.data;
  } catch (error) {
    console.error("Error creating products at service:", error);

    if (error.response && error.response.status === 403) {
      return { error: true, message: "Permission denied" };
    }

    throw error;
  }
};

export const fetchV1ProductVariants = async (page = 1, pageSize = 5) => {
  page = page ?? 1;
  pageSize = pageSize ?? 8;
  let URL = `${API_BASE_URL}/${content}/${version}/product-variants/?page_size=${pageSize}&page=${page}`;

  console.log("Product Variants API:", URL, page, pageSize);

  try {
    const response = await api.get(URL);
    return response.data;
  } catch (error) {
    console.error("Error fetching Product Variants:", error);
    throw error;
  }
};

export const createV1ProductVariants = async (data) => {
  const URL = `${API_BASE_URL}/${content}/${version}/product-variants/`;
  try {
    const response = await api.post(URL, data);
    return response.data;
  } catch (error) {
    console.error("Error creating product-variants at service:", error);

    if (error.response && error.response.status === 403) {
      return { error: true, message: "Permission denied" };
    }

    throw error;
  }
};

export const fetchV1ProductVariant = async (sku = null) => {
  let URL = `${API_BASE_URL}/${content}/${version}/product-variants/${sku}`;
  console.log("Product Variant API:", URL);

  try {
    const response = await api.get(URL);
    return response.data;
  } catch (error) {
    console.error("Error fetching Product Variant:", error);
    throw error;
  }
};

export const editV1ProductVariant = async (sku = null, data = {}) => {
  let URL = `${API_BASE_URL}/${content}/${version}/product-variants/${sku}/`;
  console.log("Product Variant API:", URL);

  try {
    const response = await api.patch(URL, data);
    return response.data;
  } catch (error) {
    console.error("Error patch Product Variant:", error);
    throw error;
  }
};

// stocks
export const fetchV1Stocks = async (page = 1, pageSize = 5, category = null) => {
  page = page ?? 1;
  pageSize = pageSize ?? 8;
  let URL = `${API_BASE_URL}/${content}/${version}/stocks/?page_size=${pageSize}&page=${page}`;

  if (category) {
    URL += `&category=${category}`;
  }

  console.log("stocks API:", URL, page, pageSize);

  try {
    const response = await api.get(URL);
    return response.data;
  } catch (error) {
    console.error("Error fetching stocks:", error);
    throw error;
  }
};

export const searchV1Stocks = async (query = "", page = 1, pageSize = 8) => {
  page = page ?? 1;
  pageSize = pageSize ?? 8;
  const URL = `${API_BASE_URL}/${content}/${version}/stocks?page_size=${pageSize}&page=${page}&search=${encodeURIComponent(
    query
  )}`;

  console.log("Search stocks API:", URL);

  try {
    const response = await api.get(URL);
    return response.data;
  } catch (error) {
    console.error("Error searching stocks:", error);
    throw error;
  }
};

export const fetchV1StockTransactions = async (page = 1, pageSize = 5) => { 
  let URL = `${API_BASE_URL}/${content}/${version}/stock-movements/?page_size=${pageSize}&page=${page}`;

  try {
    const response = await api.get(URL);
    return response.data;
  } catch (error) {
    console.error("Error fetching stock movements:", error);
    throw error;
  }
};